import { setWasmUrl } from "@lottiefiles/dotlottie-react";

/**
 * Serve the Lottie renderer's WebAssembly from our own origin.
 *
 * By default `@lottiefiles/dotlottie-web` fetches it from
 * `https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web@<version>/dist/dotlottie-player.wasm`.
 * On a network that cannot reach jsdelivr — a filtered school connection, a
 * laptop offline, a CSP added to the Static Web App later — that request fails,
 * and it fails QUIETLY: the player still mounts its canvas and the caption
 * still renders, so the only symptom is an animation that never appears.
 *
 * The file is copied into public/ by scripts/copy-lottie-wasm.mjs, which runs
 * from prebuild and predev. It is NOT imported with `?url`: the package's
 * exports map does not expose dist/*.wasm, and a deep import fails the build
 * with `Missing "./dist/dotlottie-player.wasm" specifier`.
 *
 * Called once from the entry point rather than from whichever component happens
 * to show a spinner — cc-ui renders Lottie too, and the setting is global to
 * the module. `setWasmUrl` is imported from dotlottie-react because that is
 * what both cc-ui and pymble-ui render through; it sets the URL on the worker
 * and non-worker players alike.
 *
 * Version coupling is the thing to watch. The binary must match the
 * `dotlottie-web` the player runs, which is why it and
 * `@lottiefiles/dotlottie-react` are pinned exactly in package.json rather than
 * floating as transitive dependencies of cc-ui and pymble-ui. Bump them
 * together, and let the copy script take the new binary across.
 */
export function configureLottieWasm(): void {
	setWasmUrl("/dotlottie-player.wasm");
}
